import { useState } from "react";
import { Icon } from "./icons";

/** PasswordLineEdit: an input with a show/hide toggle. */
export function PasswordInput({ value, onChange, placeholder, id, onEnter, autoComplete = "current-password" }: {
  value: string; onChange: (v: string) => void; placeholder?: string; id?: string; onEnter?: () => void; autoComplete?: string;
}) {
  const [shown, setShown] = useState(false);
  return (
    <div className="password-field">
      <input
        id={id} className="input" type={shown ? "text" : "password"} value={value} placeholder={placeholder}
        autoComplete={autoComplete}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") onEnter?.(); }}
      />
      <button type="button" aria-pressed={shown} title={shown ? "Hide password" : "Show password"} onClick={() => setShown(!shown)}><Icon name={shown ? "eyeOff" : "eye"} /></button>
    </div>
  );
}
